/* UGS: menu links that point at a section on the current page (e.g. /products/…#reviews)
   close the mobile menu first, then glide to the section. Links to other pages load normally. */
document.addEventListener('click', function (event) {
  var link = event.target.closest('a[href*="#"]');
  if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey) return;
  var url = new URL(link.href, window.location.href);
  if (url.pathname !== window.location.pathname || !url.hash || url.hash.length < 2) return;
  var target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
  if (!target) return;
  event.preventDefault();

  var drawer = link.closest('details[open]');
  var delay = 0;
  if (drawer) {
    var summary = drawer.querySelector(':scope > summary');
    if (summary) summary.click();
    else drawer.removeAttribute('open');
    document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
    delay = 350;
  }
  setTimeout(function () {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    history.replaceState(null, '', url.hash);
  }, delay);
});

/* Arriving from another page (e.g. Home menu → /products/…#reviews): the subscription app rewrites the
   product URL on load and drops the #section, so read the original address and glide there once loaded. */
(function () {
  var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  var hash = (nav && nav.name ? new URL(nav.name) : window.location).hash;
  if (!hash || hash.length < 2) return;
  var id = decodeURIComponent(hash.slice(1));
  function go() {
    var target = document.getElementById(id);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  if (document.readyState === 'complete') setTimeout(go, 300);
  else window.addEventListener('load', function () { setTimeout(go, 300); });
})();
